export default __webpack_public_path__ + "static/media/sort.4e1dfd5f.svg";